import '../base';

import '../settings/animation';
import { initAnimations } from "../animations";
import { initGlobalLineAnimations } from "../animations/line-animation";

// Objects & Web Components
import '../objects/light-box';
import '../objects/quantity-selector';
import '../objects/web-share-wrapper';
import '../objects/contact-form';
import '../objects/back-in-stock-form';

import { Disclosure } from '../objects/disclosure';
import { rebindWishlist } from '../objects/swym-wishlist';

// Global components (Static & NOT dynamic OS2 sections)
import '../components/navigation/header';
import '../sections/predictive-search';


const SELECTOR_DISCLOSURE_LOCALE = '[data-disclosure-locale]';
const SELECTOR_DISCLOSURE_CURRENCY = '[data-disclosure-currency]';

// Let CSS know JS is available
document.documentElement.classList.remove('js-unavailable');
document.documentElement.classList.add('js-available');


document.addEventListener('DOMContentLoaded', () => {
  initAnimations();
  initGlobalLineAnimations();

  const disclosureSelectors = [
    SELECTOR_DISCLOSURE_LOCALE,
    SELECTOR_DISCLOSURE_CURRENCY,
  ];
  const disclosureElements = document.querySelectorAll<HTMLElement>(disclosureSelectors.join(','));

  disclosureElements.forEach((el) => {
    new Disclosure(el);
  });

  rebindWishlist();
});
